export default __webpack_public_path__ + "static/media/icon-trivia.24fa6870.svg";